/**
 * @flow
 * @relayHash 6e455e7f5f430cfd82f5a4cd1ea0f1db
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateUserInput = {
  clientMutationId?: ?string,
  id: string,
  first_name?: ?string,
  last_name?: ?string,
  company_name?: ?string,
  s_text_on_embed_submit?: ?boolean,
  s_country?: ?string,
  s_currency?: ?string,
  s_time_zone?: ?string,
  s_recaptcha_enabled?: ?boolean,
  s_recaptcha_site_key?: ?string,
  s_recaptcha_secret_key?: ?string,
};
export type AccountInfo_UpdateUserMutationVariables = {|
  input: UpdateUserInput
|};
export type AccountInfo_UpdateUserMutationResponse = {|
  +updateUser: ?{|
    +user: ?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +company_name: ?string,
      +s_time_zone: ?string,
    |}
  |}
|};
export type AccountInfo_UpdateUserMutation = {|
  variables: AccountInfo_UpdateUserMutationVariables,
  response: AccountInfo_UpdateUserMutationResponse,
|};
*/


/*
mutation AccountInfo_UpdateUserMutation(
  $input: UpdateUserInput!
) {
  updateUser(input: $input) {
    user {
      id
      first_name
      last_name
      company_name
      s_time_zone
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateUser",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UpdateUserInput!"
      }
    ],
    "concreteType": "UpdateUserPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "first_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "last_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "company_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_time_zone",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "AccountInfo_UpdateUserMutation",
  "id": null,
  "text": "mutation AccountInfo_UpdateUserMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      id\n      first_name\n      last_name\n      company_name\n      s_time_zone\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AccountInfo_UpdateUserMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "AccountInfo_UpdateUserMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '65a95f54bf734ff36b603c1555c021b9';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/App/__generated__/AccountInfo_UpdateUserMutation.graphql.js